import thunked, { setExtraArgument } from './thunked'

export { default as getDecoratedFetch } from './getDecoratedFetch'
export { default as setIntervalBackOff } from './backOff'
export { setExtraArgument }
export default thunked
